import React, { useEffect } from 'react';
import QuoteModal from './QuoteModal';
import { createRoot } from 'react-dom/client';
import useStore from './store';
const ModalWrapper = () => {
    const { isOpen, setOpen, setClose } = useStore();
    useEffect(() => {
        const button = document.getElementById("quoteModalBtn");
        const links = document.querySelectorAll(".quote-link");
        if (button) {
            button.addEventListener("click", () => setOpen());
        }
        if (links) {
            links.forEach(link => {
                link.addEventListener("click", () => setOpen());
            });
        }
        return () => {
            if (button) {
                button.removeEventListener("click", () => setOpen());
            }
            if (links) {
                links.forEach(link => {
                    link.removeEventListener("click", () => setOpen());
                });
            }
        };
    }, []);
    if (!document.getElementById("quoteModalBtn")) {
        return null;
    }
    return React.createElement(QuoteModal, { isOpen: isOpen, onClose: () => setClose() });
};
const modalRoot = document.getElementById("quote-modal-root");
if (modalRoot) {
    createRoot(modalRoot).render(React.createElement(ModalWrapper, null));
}
